import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import { useStyles } from '../adminStyles';
import { getProjectList, saveProject,deleteProject } from '../../../redux/projects/projectsActions.js';
import { Grid, Button, TextField } from '@material-ui/core';
import DateFnsUtils from '@date-io/date-fns';
import PersonAddIcon from '@material-ui/icons/PersonAdd';
import ProjectTable from './components/ProjectTable';
import ExcelExport from './components/ExportExcel';

const columns = [
  { id: 'projectName', label: 'Project Name', align: 'center' },
  { id: 'client', label: 'Client', align: 'center' },
  { id: 'startDate', label: 'Start Date', align: 'center' },
  { id: 'endDate', label: 'End Date', align: 'center' },
  { id: 'action', label: 'Action', align: 'center' },
];

const ProjectsManage = props => {
  document.title = 'Sciata Projects';

  const { gridElRight, gridElLeft, btnMobile, inputMobile } = useStyles();

  const dispatch = useDispatch();
  const projectsList = useSelector(state => state.projects.allProjects || []);

  const [orderAscending, setOrderAscending] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [asc, setAsc] = useState('desc');
  const [rows, setRows] = useState([]);
  const [selectedProject, setSelectedProject] = useState({});

  useEffect(() => {
    bindProjects();
  }, []);

  useEffect(() => {
    setRows(projectsList);
  }, [projectsList]);

  const bindProjects = () => dispatch(getProjectList());
  const sortArray = (arr, property) => {
    let array = [...arr];
    setOrderAscending(!orderAscending);
    orderAscending ? setAsc('asc') : setAsc('desc');
    if (typeof property === 'string') {
      setRows(
        array.sort((a, b) => {
          let stringA = (a.property || '').toString().toUpperCase();
          let stringB = (a.property || '').toString().toUpperCase();

          if (orderAscending) {
            if (stringA < stringB) return -1;
            if (stringA > stringB) return 1;
            return 0;
          }
          if (!orderAscending) {
            if (stringB < stringA) return -1;
            if (stringB > stringA) return 1;
            return 0;
          }
        })
      );
    }

    property && orderAscending
      ? setRows(array.sort((a, b) => a[property] - b[property]))
      : setRows(array.sort((a, b) => b[property] - a[property]));

    property && !orderAscending
      ? setRows(array.sort((a, b) => b[property] - a[property]))
      : setRows(array.sort((a, b) => a[property] - b[property]));
    return array;
  };

  const setTheSearchTerm = e => setSearchTerm(e.target.value);

  const projectTableProps = {
    columns,
    rows,
    sortArray,
    orderAscending,
    asc,
    searchTerm,
    ...props,
  };

  const onEditClick = project => setSelectedProject(project);

  return (
    <>
      <h1>Projects Management</h1>
      <Grid container justify='center' alignItems='center'>
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <Grid item xs={12} md={6} className={gridElLeft}>
            <TextField
              type='search'
              label='Search'
              variant='outlined'
              value={searchTerm}
              onChange={setTheSearchTerm}
              className={inputMobile}
            />
          </Grid>
          <Grid item xs={12} md={6} className={gridElRight}>
            <ExcelExport {...projectTableProps} />
            <Button
              className={btnMobile}
              variant='contained'
              color='primary'
              startIcon={<PersonAddIcon />}
              onClick={() => {
                setSelectedProject({});
                props.history.push('/admin/projectdetails/0');
              }}
            >
              Add Project
            </Button>
          </Grid>
        </MuiPickersUtilsProvider>
      </Grid>
      <ProjectTable {...projectTableProps} onEditClick={onEditClick} deleteProject={(id)=>{
        dispatch(deleteProject(id));
      }}/>
    </>
  );
};

export default withRouter(ProjectsManage);
